import { render, staticRenderFns } from "./Light65Fluffy.vue?vue&type=template&id=4c1a8960&scoped=true&"
import script from "./Light65Fluffy.vue?vue&type=script&lang=js&"
export * from "./Light65Fluffy.vue?vue&type=script&lang=js&"
import style0 from "./Light65Fluffy.vue?vue&type=style&index=0&id=4c1a8960&lang=scss&scoped=true&"
import style1 from "./Light65Fluffy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1a8960",
  null
  
)

export default component.exports